import GlobalStore from "@ipru-common/store/GlobalStore";
import { convertToDateTime, getCookie, readQueryParams, splitFullName } from "../CommonFunctions";
import { OPTION_VALUES } from "@ipru-common/constants/InputValues";
import { LMS_CONSTANTS } from "@ipru-common/constants/SiteConstants";
import { mapDataToSuitabilityData } from "@ipru-common/components/CommonComponents/SuitabilityCalModal/SuitabilityMapper";
import { getAge } from "@ipru-common/libs/ValidationSchemas/CustomRules";
import { getWOPOption, trueFalse, yesNo } from "../SavingsAppForm/SavingAppFormsUtils";
import { PRODUCT_NAMES } from "@ipru-common/constants/products";
import QuoteFormStore from "@ipru-common/store/QuoteFormStore";
import { calculateSAMultiple } from "../SmartKidQuote/commonUtils";

const getGiftProNetCoreInput = () => {
  const { appFormData, quoteFormData, calculatorFormData, savingForm, existingCustomer, currentPageStep } =
    GlobalStore.getSnapshot();
  const suitabilityData = mapDataToSuitabilityData(calculatorFormData, quoteFormData);
  const queryParams = readQueryParams();
  const { isWopSelected, wopOption } = getWOPOption(quoteFormData?.selectedRiders);
  const { personalDetails } = appFormData;
  const RiderOptionAdded =
    !!quoteFormData?.selectedRiders?.length > 0 ? OPTION_VALUES.TRUE_STRING : OPTION_VALUES.FALSE_STRING;
  const UID = queryParams.get("UID") || "480";
  const QuoteFormValues = QuoteFormStore.getQuoteFormData();

  const visitorId = getCookie("GA_VisitorID") || "";
  const userName = personalDetails?.full_name ? splitFullName(personalDetails?.full_name) : "";
  let giftProInput = {
    age: calculatorFormData?.age,
    annualincome: parseInt(calculatorFormData?.yr_income),
    city: calculatorFormData?.city,
    dob: convertToDateTime(calculatorFormData?.user_dob),
    emailid: calculatorFormData?.emailid,
    existing_cust: calculatorFormData?.employeeId || existingCustomer ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,
    gender: calculatorFormData?.gender,
    income_frequency: quoteFormData?.incomeForFrequency,
    lifecover: quoteFormData?.lifeCover,
    mobileno: calculatorFormData?.mobileno,
    modalpremium: quoteFormData?.invest,
    mode: suitabilityData?.mode,
    p_gender: calculatorFormData?.propGender,
    payoutterm: quoteFormData?.incomeFor || "",
    pincode: calculatorFormData?.pincode,
    policyterm: quoteFormData?.term,
    ppt: quoteFormData?.ppt,
    productid: calculatorFormData?.productCode,
    relation: suitabilityData?.relation,
    staff: calculatorFormData?.staff === OPTION_VALUES.STAFF_N ? OPTION_VALUES.N_NO : OPTION_VALUES.Y_YES,
    term: quoteFormData?.term,

    paymentfrequency: quoteFormData?.paymentFrequency,
    firstname: "",
    lastname: "",
    address: personalDetails?.full_address,
    premium: quoteFormData?.invest + +quoteFormData?.riderPremium,
    occupation: calculatorFormData?.calc_occupation,
    nominee: personalDetails?.nominee_fullname,
    trai: calculatorFormData?.trai_flag,
    paymentoption: LMS_CONSTANTS[quoteFormData?.paymentOption],
    invest_type: suitabilityData?.invest_type,
    outputobjhold_4: suitabilityData?.OutputObjHold_4,
    outputobjhold_8: suitabilityData?.OutputObjHold_8,
    uid: UID,
    step: `step${savingForm?.currentStep}`,
    adbr: suitabilityData?.adbr,
    payout: LMS_CONSTANTS[quoteFormData?.payoutType] ?? "LumpSum",
    invest_strat: suitabilityData?.invest_strat,
    fundcat: "", //suitabilityData?.fundCat
    page_title: PRODUCT_NAMES.UlipSignatureCalculator,
    name: personalDetails?.full_name,
    selectoption_dropdown: 0,
    investvalue: quoteFormData?.invest,
    traiflag: yesNo(calculatorFormData?.trai_flag),
    appformdetails: "",
    communication: "",
    health: "",
    existingcustomer: yesNo(existingCustomer?.clientId),

    stay_details: "",
    proposer_stay_details: "",
    rideroptionadded: RiderOptionAdded,
    rider1: quoteFormData?.selectedRiders?.[0]?.sectionName,
    rider2: quoteFormData?.selectedRiders?.[1]?.sectionName,
    rider3: quoteFormData?.selectedRiders?.[2]?.sectionName,
    wop_selctedoption: wopOption,
    education: calculatorFormData?.calc_education,
    iswhatsappopted: yesNo(quoteFormData?.wth_option),
    isnri: trueFalse(calculatorFormData.nri) ? OPTION_VALUES.TRUE_STRING : OPTION_VALUES.FALSE_STRING,
    lms_nri: calculatorFormData?.nri,

    iswop: yesNo(isWopSelected),
    propage: calculatorFormData?.propAge ? getAge(calculatorFormData?.propAge) : "",
    propdob: calculatorFormData?.propAge ?? "",
    propgender: calculatorFormData?.propGender,

    p_ender: calculatorFormData?.propGender,
    deathbenefitoption: "",
    isandroid: new URL(window.location.href).searchParams.get("device") === "android",
    isios: new URL(window.location.href).searchParams.get("device") === "ios",
    maritalstatus: personalDetails?.marital_status,
    appno: appFormData?.appNO,
    selectedfunds: "",
    productselection: "",
    kycwaveoff: "",
    suitabilitymatrix: "", // suitabilityMatrix,
    pan_validation_status: "",
    ekycdetails: "",
    savingspercentage: suitabilityData?.pastPerformancePercent,
    lead_type: currentPageStep != "appFormScreen" ? "Lead" : "Drop",
    payoutoption: LMS_CONSTANTS[quoteFormData?.payoutType],
    transactionid: appFormData?.transactionId,
    emp_id: calculatorFormData?.employeeId ?? "",
    ekyc_flag: appFormData?.Ekyc?.EKYC_flag,
    ckycflag: appFormData?.CkycJson?.CKYCflag,

    // NOT IN SIGNATURE NET CORE , BUT NEEDED BEC OF COMMON IMPLEMENTATION
    currentpagestep: currentPageStep,
    isenglish: "TRUE",
    trai_flag: yesNo(calculatorFormData?.trai_flag),

    fname: userName?.firstName,
    lname: userName?.lastName,

    existingcust_pasa: "NO",
    guaranteedcashbenefit: quoteFormData?.calculatedData?.giftProData?.guaranteedCashBenefitNumber,
    guaranteedcashbenefit2: quoteFormData?.calculatedData?.giftProData?.guaranteedCashBenefitNumber,
    guranteed_returns: quoteFormData?.calculatedData?.giftProData?.income,
    income_frequenc: quoteFormData?.incomeForFrequency,

    status: "",
    total_amount: quoteFormData?.calculatedData?.giftProData?.overallReturns,

    samultiple:
      quoteFormData?.ppt && calculatorFormData?.age
        ? calculateSAMultiple({
            PremiumPaymentTerm: quoteFormData?.ppt || 0,
            age: calculatorFormData?.age,
          })
        : 0,
    whole_life: suitabilityData?.whole_life,
    calctype: "",
    defermentperiod: QuoteFormValues.ppt === 5 ? 3 : "",
    employeeid: calculatorFormData?.employeeId || existingCustomer ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,
    optforrop: QuoteFormValues.wantMoneyback || "",
    mbpercentage: QuoteFormValues.getMoneyBackPct,
    mbbenefityear: QuoteFormValues.getMoneyBackYear,
    lcbflag: QuoteFormValues.incomeBooster,
    whatsapp_flag: yesNo(calculatorFormData?.trai_flag),
    checktwo: "",
    lduid: UID || 480,
    lduid_source: "",
    getincome: quoteFormData?.calculatedData?.giftProData?.income,
    pensionfrequency: "",
    optformaturity: "No",
    desiredlifecover: quoteFormData?.lifeCover,
    incomemode: quoteFormData?.customiseIncome,
    _epoch: "",
    _visid: visitorId,

    pfp_pk_id: "",
    pri_medical_data: "",
    state: calculatorFormData?.state,
  };

  return giftProInput;
};

export default getGiftProNetCoreInput;
